export enum ContentBodyTypeEnum {
  video = "VideoBody",
  article = "ArticleBody",
  audio = "AudioBody",
  photo = "PhotoBody",
}

export enum ContentAspectEnum {
  ratio1x1 = "1:1",
  ratio4x3 = "4:3",
  ratio4x5 = "4:5",
  ratio9x16 = "9:16",
  ratio16x9 = "16:9",
}

export enum ContentSourceEnum {
  youtube = "YouTube",
  tiktok = "TikTok",
  vimeo = "Vimeo",
  instagram = "Instagram",
  spotify = "Spotify",
  appleMusic = "Apple Music",
  soundcloud = "SoundCloud",
  pinterest = "Pinterest",
  unsplash = "Unsplash",
  other = "Other",
}

export interface ContentBody {
  id: number
  type: ContentBodyTypeEnum
  playable: boolean
  readable_duration: string | null
  source: ContentSourceEnum | null
  caption: string | null
  aspect: ContentAspectEnum | null
  // Polymorphic fields — serialized by ContentBodyResource; each is present
  // only on the matching body subtype (video/audio/article/photo), nil
  // otherwise. Keeping them on the base union for simplest consumer access.
  duration_seconds: number | null
  transcript: string | null
  body: string | null
  reading_time: number | null
  alt_text: string | null
  image_url: string | null
}
